import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, CheckCircle2, TrendingUp, ShieldCheck, Users, Zap, HeartPulse } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxoaWdoJTIwZW5kJTIwZml0bmVzcyUyMGd5bXxlbnwwfHx8fDE3ODMwMDQ0OTJ8MA&ixlib=rb-4.1.0&q=85";

export default function BecomeTrainerPage() {
  return (
    <div>
      <section className="relative h-[520px] overflow-hidden">
        <img src={HERO} className="absolute inset-0 w-full h-full object-cover" alt="Gym"/>
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 to-black/40"/>
        <div className="relative container-fl h-full flex flex-col justify-center text-white">
          <div className="overline text-emerald-400 mb-3">Become a FitLink trainer</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter max-w-3xl leading-[1.05]">
            Fill your calendar with <span className="text-emerald-400">verified clients.</span>
          </h1>
          <p className="mt-6 text-lg text-neutral-200 max-w-xl">Zero setup fees. Get paid securely. Focus on coaching — we handle the rest.</p>
          <Link to="/signup?role=trainer" data-testid="become-signup" className="btn-accent mt-8 w-fit">Apply now <ChevronRight size={14}/></Link>
        </div>
      </section>

      <section className="container-fl py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { icon: <Users/>, t: "Reach thousands", d: "Get discovered by clients across Ireland searching by county, gym and goal." },
            { icon: <TrendingUp/>, t: "Grow your business", d: "Take payments, manage bookings and build reviews to boost your reputation." },
            { icon: <ShieldCheck/>, t: "Verified trust", d: "Our approval process gives clients confidence — you get higher conversion." },
          ].map((f, i) => (
            <div key={i} className="card-fl p-8">
              <div className="w-11 h-11 rounded-lg bg-emerald-100 text-emerald-700 grid place-items-center mb-4">{f.icon}</div>
              <h3 className="font-bold text-lg mb-1">{f.t}</h3>
              <p className="text-neutral-600 text-sm">{f.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-neutral-950 text-white py-20">
        <div className="container-fl grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="overline text-emerald-400 mb-3">How you'll earn</div>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6">Simple, transparent revenue.</h2>
            <ul className="space-y-3 text-neutral-200">
              {["Set your own prices per service","Accept or decline any booking","Weekly payouts to your bank","Keep 90% of every session"].map((s, i) => (
                <li key={i} className="flex items-center gap-2"><CheckCircle2 size={16} className="text-emerald-500"/> {s}</li>
              ))}
            </ul>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {[
              { t: "10+", d: "avg bookings / week" },
              { t: "€2.4k", d: "avg monthly earnings" },
              { t: "4.9", d: "avg rating" },
              { t: "48h", d: "approval SLA" },
            ].map((k, i) => (
              <div key={i} className="rounded-xl border border-neutral-800 bg-neutral-900 p-6">
                <div className="text-3xl font-black text-emerald-400">{k.t}</div>
                <div className="text-neutral-400 text-sm mt-1">{k.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-fl py-20 text-center">
        <div className="overline mb-2">Ready?</div>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6">Start growing your PT business today.</h2>
        <Link to="/signup?role=trainer" data-testid="become-signup-2" className="btn-primary">Create trainer account <ChevronRight size={14}/></Link>
      </section>
    </div>
  );
}
